export default function FormatTimer({sla}){
    const minutos = Math.floor(sla / 60);
    const segundosRestantes = sla % 60;

    return (
        <div>
            <p className="numero">{minutos}:{segundosRestantes} SEGUNDOS</p>
        </div>
    )
}